module.exports = __webpack_public_path__ + "static/media/teams-gray.d53ff6c5.svg";